import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { selectProfileByType } from '@era/stores';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { AsyncResultComponent, PaneComponent, PanelComponent } from '@rocksoft/cdk';

import { AsyncPipe } from '@angular/common';
import { DeviceInformation } from '@rocksoft/mdm-sdk-v2';
import { isNotUndefined } from '@rocksoft/shared';
import { filter, Observable } from 'rxjs';
import { OSSupportedPipe } from '../../pipes/os-supported.pipe';
import { AppleDeviceLockComponent } from './commands/apple-device-lock/apple-device-lock.component';
import { AppleLostModeComponent } from './commands/apple-lost-mode/apple-lost-mode.component';
import { ClearPasscodeComponent } from './commands/clear-passcode/clear-passcode.component';
import { DeviceLocationComponent } from './commands/device-location/device-location.component';
import { EraseDeviceComponent } from './commands/erase-device/erase-device.component';
import { RestartDeviceComponent } from './commands/restart-device/restart-device.component';
import { ShutdownDeviceComponent } from './commands/shutdown-device/shutdown-device.component';

@Component({
  selector: 'ml-mdm-apple-admin',
  templateUrl: './apple-admin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PanelComponent,
    AsyncResultComponent,
    AppleDeviceLockComponent,
    PaneComponent,
    RestartDeviceComponent,
    FaIconComponent,
    ShutdownDeviceComponent,
    AppleLostModeComponent,
    ClearPasscodeComponent,
    DeviceLocationComponent,
    EraseDeviceComponent,
    OSSupportedPipe,
    AsyncPipe,
  ],
})
export class AppleAdminComponent {
  private readonly store = inject(Store);

  public readonly apple$: Observable<DeviceInformation> = this.store
    .select(selectProfileByType('device-information'))
    .pipe(filter(isNotUndefined));
}
